// extracted by mini-css-extract-plugin
module.exports = {"supportItem":"SupportItem_supportItem__fisSE","iconWrapper":"SupportItem_iconWrapper__7bbZU","logo":"SupportItem_logo__Uvgou"};